document.addEventListener('click', function (e) {
  // quantity stepper
  var step = e.target.closest('[data-step]');
  if (step) {
    var input = document.getElementById(step.dataset.for);
    if (input) {
      var next = parseInt(input.value, 10) + parseInt(step.dataset.step, 10);
      input.value = next < 1 ? 1 : next;
    }
    return;
  }
  // gallery thumbnails
  var thumb = e.target.closest('[data-full]');
  if (thumb) {
    var main = document.getElementById('PdpMain');
    if (main) { main.src = thumb.dataset.full; main.alt = thumb.dataset.alt || main.alt; }
    document.querySelectorAll('[data-full]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  }
});
